import { Route, Routes } from 'react-router-dom';
import { DriverShell } from '../layout/DriverShell';
import { RequireAuth } from '../lib/auth';
import { SignInPage } from './SignInPage';
import { TodayPage } from './TodayPage';
import { JobsPage } from './JobsPage';
import { JobDetailPage } from './JobDetailPage';
import { ProfilePage } from './ProfilePage';
import { NotificationsPage } from './NotificationsPage';

export function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignInPage />} />
      <Route
        element={
          <RequireAuth>
            <DriverShell />
          </RequireAuth>
        }
      >
        <Route index element={<TodayPage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="jobs/:id" element={<JobDetailPage />} />
        <Route path="alerts" element={<NotificationsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="*" element={<TodayPage />} />
      </Route>
    </Routes>
  );
}
